module.exports = __webpack_public_path__ + "img/rouler_positions_6.410ad40e.png";